import { Colors } from '@sigma-frontend-libs/commons'

import { components, icons, services } from '@/utils'

import preloader from '@/components/preloader'
import sourceBox from '@/components/source/box'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderPreloader(h) {
  return h(
    'div',
    {
      class: 'preloader__holder preloader__holder--absolute pa-5'
    },
    [ h(preloader) ]
  )
}
function renderAbsolutePreloader(h) {
  if (this.loading) {
    return h(
      'div',
      {
        class: 'preloader__holder preloader__holder--absolute'
      },
      [ h(preloader) ]
    )
  }
}

function renderDate(h, item) {
  return h(
    date,
    {
      props: {
        value: item,
        field: 'time'
      }
    }
  )
}
function renderDirection(h, item) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${services.providers}.logs.directions.${item.direction}`),
        label: this.getTranslate(`${services.sendings}.labels.direction`),
        icon: item.direction === 'incoming' ? icons.arrow_drop_down : icons.arrow_drop_up,
        color: item.direction === 'incoming' ? Colors.primary : Colors.success
      }
    }
  )
}
function renderProtocol(h, item) {
  return h(
    sticker,
    {
      props: {
        value: item.protocol.toUpperCase(),
        label: this.getTranslate(`${services.sendings}.labels.protocol`),
        icon: item.protocol === 'http' ? icons.http : icons.https ?? icons.question_mark,
        color: Colors.grey
      }
    }
  )
}
function renderType(h, item) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${services.providers}.logs.types.${item.type}`),
        label: this.getTranslate(`${services.sendings}.labels.type`),
        icon: item.type === 'request' ? icons.send : icons.received,
        color: item.type === 'request' ? Colors.primary : Colors.success
      }
    }
  )
}
function renderItemHeader(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-providers-logs-item__header`
    },
    [
      renderDate.call(this, h, item),
      renderDirection.call(this, h, item),
      renderProtocol.call(this, h, item),
      renderType.call(this, h, item)
    ]
  )
}
function renderItemBody(h, { payload }) {
  if (payload) {
    return h(
      sourceBox,
      {
        props: { value: payload }
      }
    )
  }
}
function renderItem(h, item) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-providers-logs-item`
    },
    [
      renderItemHeader.call(this, h, item),
      renderItemBody.call(this, h, item)
    ]
  )
}
function renderItems(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-providers-logs-items`
    },
    [
      this.items.map(item => {
        return renderItem.call(this, h, item)
      }),

      renderAbsolutePreloader.call(this, h)
    ]
  )
}
function renderBody(h) {
  if (Array.isArray(this.items) && this.items.length) {
    return renderItems.call(this, h)
  } else {
    switch (this.loading) {
      case true: return renderPreloader.call(this, h)
      case false:
      default: return h(components.empty)
    }
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${services.sendings}-item__tabs-providers-logs`
    },
    [ renderBody.call(this, h) ]
  )
}
